/**
 * Permission keys returned by GET /api/rbac/context.
 * Use these constants — never hardcode role names.
 */
export const RbacPermissions = {
  DeviceDetails_DeviceConfigHistory: 'DeviceDetails_DeviceConfigHistory',
  DeviceDetails_DeviceHealth: 'DeviceDetails_DeviceHealth',
  DeviceDetails_DeviceHistory: 'DeviceDetails_DeviceHistory',
  DeviceDetails_Engineering: 'DeviceDetails_Engineering',
  DeviceDetails_InstallerLog: 'DeviceDetails_InstallerLog',
  DeviceDetails_SimDetails: 'DeviceDetails_SimDetails',
  DeviceDetails_Peripherals: 'DeviceDetails_Peripherals',
  DeviceList_View: 'DeviceList_View',
  DeviceList_BulkEdit: 'DeviceList_BulkEdit',
  DeviceList_Edit_ActionCol: 'DeviceList_Edit_ActionCol',
  DeviceList_Export_Button: 'DeviceList_Export_Button',
  OTA_ConfigurationHistory_View: 'OTA_ConfigurationHistory_View',
  OTA_ConfigurationHistory_Export: 'OTA_ConfigurationHistory_Export',
  OTA_ConfigurationList_View: 'OTA_ConfigurationList_View',
  OTA_ConfigurationList_Update: 'OTA_ConfigurationList_Update',
  OTA_UploadConfigurationFile: 'OTA_UploadConfigurationFile',
  Onboarding_Upload_DeviceXLSheet: 'Onboarding_Upload_DeviceXLSheet',
  TealInte_APILog: 'TealInte_APILog',
  TealInte_OperationRes: 'TealInte_OperationRes',
  TealInte_SIMInfo: 'TealInte_SIMInfo',
  UserMgmt_Customer_View: 'UserMgmt_Customer_View',
  UserMgmt_Customer_Add: 'UserMgmt_Customer_Add',
  UserMgmt_Customer_Edit: 'UserMgmt_Customer_Edit',
  UserMgmt_Customer_Delete: 'UserMgmt_Customer_Delete',
  UserMgmt_Group_View: 'UserMgmt_Group_View',
  UserMgmt_Group_Add: 'UserMgmt_Group_Add',
  UserMgmt_Group_Edit: 'UserMgmt_Group_Edit',
  UserMgmt_Group_Delete: 'UserMgmt_Group_Delete',
  UserMgmt_GroupAssignment: 'UserMgmt_GroupAssignment',
  UserMgmt_RolePermission: 'UserMgmt_RolePermission',
  UserMgmt_UserList_View: 'UserMgmt_UserList_View',
  UserMgmt_UserList_Add: 'UserMgmt_UserList_Add',
  UserMgmt_UserList_Edit: 'UserMgmt_UserList_Edit',
  UserMgmt_UserList_Delete: 'UserMgmt_UserList_Delete',
} as const;

export type RbacPermissionKey =
  (typeof RbacPermissions)[keyof typeof RbacPermissions];

/** Device List page/menu access. */
export const RBAC_DEVICE_LIST_VIEW_PERMISSIONS: readonly string[] = [
  RbacPermissions.DeviceList_View,
  RbacPermissions.DeviceList_BulkEdit,
  RbacPermissions.DeviceList_Edit_ActionCol,
  RbacPermissions.DeviceList_Export_Button,
];

/** Any Device List or Device Details permission grants access to the Devices area. */
export const RBAC_DEVICE_MODULE_PERMISSIONS: string[] = Object.values(
  RbacPermissions
).filter(
  (permission) =>
    permission.startsWith('DeviceList_') ||
    permission.startsWith('DeviceDetails_')
);
